import { WidgetTemplateDetails } from '../../widget-template-details/WidgetTemplateDetails';
import type { WidgetTemplateDetailsEntity } from '../../widget-template-details/WidgetTemplateDetails.entity';
import type { TRenderScreen } from '../SettingsScreenRendererService';

export function renderWellLogsTemplateDetailsScreen(screen: WidgetTemplateDetailsEntity): TRenderScreen {
  return () => <WidgetTemplateDetails screen={screen} />;
}
